<bit-section [disableMargin]="disableMargin" class="bv-generator-password-settings">
  <form [formGroup]="settings" class="tw-container">
    <div class="bv-generator-password-settings__length-grid">
      <bit-form-field disableMargin>
        <bit-label>{{ "length" | i18n }}</bit-label>
        <input
          bitInput
          formControlName="length"
          type="number"
          [min]="lengthMin"
          [max]="lengthMax"
          (change)="save('length')"
        />
      </bit-form-field>
      <bit-form-field disableMargin class="bv-generator-password-settings__min-length">
        <bit-label>{{ "minPasswordLength" | i18n }}</bit-label>
        <input bitInput type="number" [value]="settings.value.length" disabled />
      </bit-form-field>
      <bit-form-field disableMargin>
        <bit-label>{{ "minNumbers" | i18n }}</bit-label>
        <input
          bitInput
          type="number"
          formControlName="minNumber"
          [min]="minNumberMin"
          [max]="minNumberMax"
          (change)="save('minNumbers')"
        />
      </bit-form-field>
      <bit-form-field disableMargin>
        <bit-label>{{ "minSpecial" | i18n }}</bit-label>
        <input
          bitInput
          type="number"
          formControlName="minSpecial"
          [min]="minSpecialMin"
          [max]="minSpecialMax"
          (change)="save('minSpecial')"
        />
      </bit-form-field>
    </div>
    <bit-hint class="bv-generator-password-settings__hint">{{
      lengthBoundariesHint$ | async
    }}</bit-hint>

    <section class="bv-generator__section bv-generator__section--options">
      <h3 class="bv-generator__heading">{{ "options" | i18n }}</h3>
      <div class="bv-generator-password-settings__options">
        <bit-form-control
          class="!tw-mb-0"
          attr.aria-description="{{ 'uppercaseDescription' | i18n }}"
          title="{{ 'uppercaseDescription' | i18n }}"
        >
          <input
            bitCheckbox
            type="checkbox"
            formControlName="uppercase"
            (change)="save('uppercase')"
          />
          <bit-label>{{ "uppercaseLabel" | i18n }}</bit-label>
        </bit-form-control>
        <bit-form-control
          class="!tw-mb-0"
          attr.aria-description="{{ 'lowercaseDescription' | i18n }}"
          title="{{ 'lowercaseDescription' | i18n }}"
        >
          <input
            bitCheckbox
            type="checkbox"
            formControlName="lowercase"
            (change)="save('lowercase')"
          />
          <bit-label>{{ "lowercaseLabel" | i18n }}</bit-label>
        </bit-form-control>
        <bit-form-control
          class="!tw-mb-0"
          attr.aria-description="{{ 'numbersDescription' | i18n }}"
          title="{{ 'numbersDescription' | i18n }}"
        >
          <input bitCheckbox type="checkbox" formControlName="number" (change)="save('number')" />
          <bit-label>{{ "numbersLabel" | i18n }}</bit-label>
        </bit-form-control>
        <bit-form-control class="!tw-mb-0" title="{{ 'specialCharactersDescription' | i18n }}">
          <input bitCheckbox type="checkbox" formControlName="special" (change)="save('special')" />
          <bit-label>
            <span aria-hidden="true">{{ "!@#$%^&*" }}</span>
            <span class="tw-sr-only">
              {{ "specialCharactersDescription" | i18n }}
            </span>
          </bit-label>
        </bit-form-control>
        <bit-form-control [disableMargin]="!policyInEffect">
          <input
            bitCheckbox
            type="checkbox"
            formControlName="avoidAmbiguous"
            (change)="save('avoidAmbiguous')"
          />
          <bit-label>{{ "avoidAmbiguous" | i18n }}</bit-label>
        </bit-form-control>
      </div>
      @if (policyInEffect) {
        <p bitTypography="helper">{{ "generatorPolicyInEffect" | i18n }}</p>
      }
    </section>
  </form>
</bit-section>
